import { useFilterFieldOptions } from './useFilterFieldOptions';

type WithFilterFieldOptionsProps = ReturnType<typeof useFilterFieldOptions>;

export const withFilterFieldOptions = <P extends object>(
  WrappedComponent: React.ComponentType<P & WithFilterFieldOptionsProps>,
) => {
  const ComponentWithFilterFieldOptions = (props: P) => {
    const filterFieldOptions = useFilterFieldOptions();
    return <WrappedComponent {...props} {...filterFieldOptions} />;
  };

  return ComponentWithFilterFieldOptions;
};
